
// Application version - change this when making new deployments
export const APP_VERSION = '1.3.0'; // Incrémenté pour forcer le rechargement

// Local storage key for storing the version
const VERSION_KEY = 'aluna-app-version';

/**
 * Checks if the application version has changed and forces reload if needed
 */
export function checkAppVersion(): void {
  // Get the stored version
  const storedVersion = localStorage.getItem(VERSION_KEY);
  
  // If there's a stored version and it's different from the current version
  if (storedVersion && storedVersion !== APP_VERSION) {
    console.log(`New version detected: ${APP_VERSION} (was ${storedVersion})`);
    
    // Clear cache if possible
    if ('caches' in window) {
      try {
        caches.keys().then(names => {
          names.forEach(name => {
            caches.delete(name);
          });
        });
      } catch (e) {
        console.error('Failed to clear cache:', e);
      }
    }
    
    // Update stored version before reload
    localStorage.setItem(VERSION_KEY, APP_VERSION);
    
    // Force reload the page without using deprecated parameter
    window.location.reload();
  } else {
    // Store the current version
    localStorage.setItem(VERSION_KEY, APP_VERSION);
  }
}

// Force initial check regardless of stored version
export function forceRefresh(): void {
  // Clear application cache
  if ('caches' in window) {
    try {
      caches.keys().then(names => {
        names.forEach(name => {
          caches.delete(name);
        });
      });
    } catch (e) {
      console.error('Failed to clear cache:', e);
    }
  }
  
  // Force reload without using deprecated parameter
  window.location.reload();
}
